// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Product onboarding — matches INCYIA shell (navy / teal / Lato) */

.ob-overlay {
  position: fixed;
  inset: 0;
  z-index: 1900;
  display: grid;
  place-items: center;
  padding: 24px;
  background:
    radial-gradient(720px 420px at 12% 8%, rgba(79, 224, 194, 0.16), transparent 62%),
    rgba(5, 14, 46, 0.62);
  backdrop-filter: blur(8px);
}

.ob-card {
  width: min(980px, 100%);
  display: grid;
  grid-template-columns: 268px 1fr;
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  box-shadow:
    0 24px 64px rgba(5, 14, 46, 0.32),
    0 0 0 1px rgba(255, 255, 255, 0.08);
  font-family: Lato, sans-serif;
}

.ob-rail {
  position: relative;
  padding: 28px 24px;
  color: #d7e0f5;
  background:
    radial-gradient(280px 180px at 0% 0%, rgba(57, 202, 171, 0.28), transparent 70%),
    linear-gradient(178deg, #050e2e 0%, #00146d 62%, #062a63 100%);
  overflow: hidden;
}

.ob-rail-mark {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.22em;
  color: #fff;
}

.ob-rail-kicker {
  margin: 28px 0 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #7fe9d2;
}

.ob-rail-lead {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.28;
  color: #fff;
}

.ob-rail-orbs {
  position: absolute;
  inset: auto 0 18px 24px;
  display: flex;
  gap: 8px;
}

.ob-rail-orbs span {
  width: 8px;
  height: 8px;
  border-radius: 99px;
  background: rgba(127, 233, 210, 0.85);
}

.ob-rail-orbs span:last-child {
  width: 28px;
  background: rgba(255, 255, 255, 0.18);
}

.ob-main {
  padding: 32px 32px 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f7f9fd 100%);
}

.ob-eyebrow {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #0d9b87;
}

.ob-title {
  margin: 0 0 10px;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.18;
  letter-spacing: -0.02em;
  color: #0b1e2d;
}

.ob-body {
  margin: 0 0 22px;
  max-width: 46ch;
  font-size: 15px;
  line-height: 1.55;
  color: #5f7484;
}

.ob-pillars {
  display: grid;
  gap: 10px;
}

.ob-pillars--grid {
  grid-template-columns: 1fr 1fr;
  counter-reset: pillar;
}

.ob-pillar {
  position: relative;
  display: grid;
  grid-template-columns: 36px 1fr;
  gap: 12px;
  align-items: start;
  padding: 12px 14px 12px 14px;
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  background: #fff;
}

.ob-pillar::after {
  counter-increment: pillar;
  content: counter(pillar, decimal-leading-zero);
  position: absolute;
  top: 10px;
  right: 12px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #b7c4ce;
}

.ob-pillar-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: #076b5c;
  background: #e1f4f0;
}

.ob-pillar h3 {
  margin: 0 0 2px;
  font-size: 14px;
  font-weight: 800;
  color: #0b1e2d;
}

.ob-pillar p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #5f7484;
}

.ob-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 22px;
  padding-top: 16px;
  border-top: 1px solid #dfe7e8;
}

.ob-duration {
  font-size: 12px;
  font-weight: 700;
  color: #5f7484;
}

.ob-foot-actions {
  display: flex;
  gap: 8px;
}

.ob-btn {
  height: 42px;
  padding: 0 16px;
  border-radius: 8px;
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  width: auto !important;
}

.ob-btn--ghost {
  border: 1px solid #dfe7e8;
  background: #fff;
  color: #0b1e2d;
}

.ob-btn--ghost:hover {
  background: #f7f9fd;
}

.ob-btn--primary {
  border: 0;
  background: #00146d;
  color: #fff;
  box-shadow: 0 8px 18px rgba(0, 20, 109, 0.22);
}

.ob-btn--primary:hover {
  background: #1b2f8f;
}

.ob-tip,
.ob-tip *::first-letter {
  text-transform: none !important;
}

.ob-tip {
  width: 380px;
  padding: 16px 16px 14px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #dfe7e8;
  box-shadow: 0 18px 44px rgba(5, 14, 46, 0.22);
  font-family: Lato, sans-serif;
}

.ob-tip-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.ob-tip-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ob-tip-chapter {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  background: #e1f4f0;
  color: #076b5c;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.ob-tip-kicker {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: #0d9b87;
}

.ob-tip-track {
  height: 4px;
  margin: 0 0 14px;
  border-radius: 99px;
  background: #e8eef0;
  overflow: hidden;
}

.ob-tip-track span {
  display: block;
  height: 100%;
  border-radius: 99px;
  background: linear-gradient(90deg, #0d9b87, #4fe0c2);
}

.ob-tip-skip,
.ob-tip-btn {
  font-family: Lato, sans-serif;
  cursor: pointer;
  width: auto !important;
}

.ob-tip-skip {
  border: 0;
  background: none;
  padding: 0;
  font-size: 12px;
  font-weight: 700;
  color: #5f7484;
}

.ob-tip-skip:hover {
  color: #0b1e2d;
}

.ob-tip-title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 800;
  color: #0b1e2d;
  line-height: 1.25;
  letter-spacing: -0.02em;
}

.ob-tip-body {
  font-size: 13.5px;
  line-height: 1.55;
  color: #5f7484;
}

.ob-tip-hint {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f4fbf9;
  border: 1px solid #d5efe8;
}

.ob-tip-hint-label {
  display: block;
  margin-bottom: 2px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #0d9b87;
}

.ob-tip-hint p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #0b1e2d;
}

.ob-tip-dots {
  display: flex;
  gap: 6px;
  margin: 14px 0 12px;
}

.ob-tip-dot {
  width: 7px;
  height: 7px;
  border-radius: 99px;
  background: #dfe7e8;
}

.ob-tip-dot.is-done {
  background: #7fe9d2;
}

.ob-tip-dot.is-on {
  width: 18px;
  background: #0d9b87;
}

.ob-tip-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 14px;
}

.ob-tip-btn {
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
}

.ob-tip-btn--ghost {
  border: 1px solid #dfe7e8;
  background: #fff;
  color: #0b1e2d;
}

.ob-tip-btn--primary {
  border: 0;
  background: #00146d;
  color: #fff;
}

.ob-anchor-tip {
  position: fixed;
  z-index: 10050;
  pointer-events: auto;
  filter: drop-shadow(0 18px 36px rgba(5, 14, 46, 0.22));
}

.ob-anchor-tip .ob-tip {
  position: relative;
}

.ob-anchor-tip--right .ob-tip::before,
.ob-anchor-tip--left .ob-tip::before,
.ob-anchor-tip--bottom .ob-tip::before,
.ob-anchor-tip--bottom-end .ob-tip::before,
.ob-anchor-tip--top .ob-tip::before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border: 8px solid transparent;
}

.ob-anchor-tip--right .ob-tip::before {
  left: -16px;
  top: 22px;
  border-right-color: #fff;
}

.ob-anchor-tip--left .ob-tip::before {
  right: -16px;
  left: auto;
  top: 22px;
  border-left-color: #fff;
}

.ob-anchor-tip--bottom .ob-tip::before,
.ob-anchor-tip--bottom-end .ob-tip::before {
  top: -16px;
  left: 28px;
  border-bottom-color: #fff;
}

.ob-anchor-tip--bottom-end .ob-tip::before {
  left: auto;
  right: 28px;
}

.ob-anchor-tip--top .ob-tip::before {
  bottom: -16px;
  top: auto;
  left: 50%;
  margin-left: -8px;
  border-top-color: #fff;
}

@media (max-width: 820px) {
  .ob-card {
    grid-template-columns: 1fr;
  }

  .ob-rail {
    min-height: 140px;
  }

  .ob-main {
    padding: 22px 18px 18px;
  }

  .ob-title {
    font-size: 22px;
  }

  .ob-foot {
    flex-direction: column;
    align-items: stretch;
  }

  .ob-foot-actions {
    justify-content: stretch;
  }

  .ob-foot-actions .ob-btn {
    flex: 1 1;
  }

  .ob-pillars--grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/onboarding/onboarding.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb;;yBAEuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB;;uCAEqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd;;kEAEgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;;EAEE,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Product onboarding — matches INCYIA shell (navy / teal / Lato) */\n\n.ob-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1900;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  background:\n    radial-gradient(720px 420px at 12% 8%, rgba(79, 224, 194, 0.16), transparent 62%),\n    rgba(5, 14, 46, 0.62);\n  backdrop-filter: blur(8px);\n}\n\n.ob-card {\n  width: min(980px, 100%);\n  display: grid;\n  grid-template-columns: 268px 1fr;\n  overflow: hidden;\n  border-radius: 18px;\n  background: #fff;\n  box-shadow:\n    0 24px 64px rgba(5, 14, 46, 0.32),\n    0 0 0 1px rgba(255, 255, 255, 0.08);\n  font-family: Lato, sans-serif;\n}\n\n.ob-rail {\n  position: relative;\n  padding: 28px 24px;\n  color: #d7e0f5;\n  background:\n    radial-gradient(280px 180px at 0% 0%, rgba(57, 202, 171, 0.28), transparent 70%),\n    linear-gradient(178deg, #050e2e 0%, #00146d 62%, #062a63 100%);\n  overflow: hidden;\n}\n\n.ob-rail-mark {\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.22em;\n  color: #fff;\n}\n\n.ob-rail-kicker {\n  margin: 28px 0 8px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #7fe9d2;\n}\n\n.ob-rail-lead {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.28;\n  color: #fff;\n}\n\n.ob-rail-orbs {\n  position: absolute;\n  inset: auto 0 18px 24px;\n  display: flex;\n  gap: 8px;\n}\n\n.ob-rail-orbs span {\n  width: 8px;\n  height: 8px;\n  border-radius: 99px;\n  background: rgba(127, 233, 210, 0.85);\n}\n\n.ob-rail-orbs span:last-child {\n  width: 28px;\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.ob-main {\n  padding: 32px 32px 24px;\n  background: linear-gradient(180deg, #ffffff 0%, #f7f9fd 100%);\n}\n\n.ob-eyebrow {\n  margin: 0 0 8px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #0d9b87;\n}\n\n.ob-title {\n  margin: 0 0 10px;\n  font-size: 28px;\n  font-weight: 800;\n  line-height: 1.18;\n  letter-spacing: -0.02em;\n  color: #0b1e2d;\n}\n\n.ob-body {\n  margin: 0 0 22px;\n  max-width: 46ch;\n  font-size: 15px;\n  line-height: 1.55;\n  color: #5f7484;\n}\n\n.ob-pillars {\n  display: grid;\n  gap: 10px;\n}\n\n.ob-pillars--grid {\n  grid-template-columns: 1fr 1fr;\n  counter-reset: pillar;\n}\n\n.ob-pillar {\n  position: relative;\n  display: grid;\n  grid-template-columns: 36px 1fr;\n  gap: 12px;\n  align-items: start;\n  padding: 12px 14px 12px 14px;\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.ob-pillar::after {\n  counter-increment: pillar;\n  content: counter(pillar, decimal-leading-zero);\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  color: #b7c4ce;\n}\n\n.ob-pillar-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  color: #076b5c;\n  background: #e1f4f0;\n}\n\n.ob-pillar h3 {\n  margin: 0 0 2px;\n  font-size: 14px;\n  font-weight: 800;\n  color: #0b1e2d;\n}\n\n.ob-pillar p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.ob-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 22px;\n  padding-top: 16px;\n  border-top: 1px solid #dfe7e8;\n}\n\n.ob-duration {\n  font-size: 12px;\n  font-weight: 700;\n  color: #5f7484;\n}\n\n.ob-foot-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.ob-btn {\n  height: 42px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  width: auto !important;\n}\n\n.ob-btn--ghost {\n  border: 1px solid #dfe7e8;\n  background: #fff;\n  color: #0b1e2d;\n}\n\n.ob-btn--ghost:hover {\n  background: #f7f9fd;\n}\n\n.ob-btn--primary {\n  border: 0;\n  background: #00146d;\n  color: #fff;\n  box-shadow: 0 8px 18px rgba(0, 20, 109, 0.22);\n}\n\n.ob-btn--primary:hover {\n  background: #1b2f8f;\n}\n\n.ob-tip,\n.ob-tip *::first-letter {\n  text-transform: none !important;\n}\n\n.ob-tip {\n  width: 380px;\n  padding: 16px 16px 14px;\n  border-radius: 14px;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  box-shadow: 0 18px 44px rgba(5, 14, 46, 0.22);\n  font-family: Lato, sans-serif;\n}\n\n.ob-tip-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.ob-tip-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ob-tip-chapter {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #e1f4f0;\n  color: #076b5c;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.ob-tip-kicker {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  color: #0d9b87;\n}\n\n.ob-tip-track {\n  height: 4px;\n  margin: 0 0 14px;\n  border-radius: 99px;\n  background: #e8eef0;\n  overflow: hidden;\n}\n\n.ob-tip-track span {\n  display: block;\n  height: 100%;\n  border-radius: 99px;\n  background: linear-gradient(90deg, #0d9b87, #4fe0c2);\n}\n\n.ob-tip-skip,\n.ob-tip-btn {\n  font-family: Lato, sans-serif;\n  cursor: pointer;\n  width: auto !important;\n}\n\n.ob-tip-skip {\n  border: 0;\n  background: none;\n  padding: 0;\n  font-size: 12px;\n  font-weight: 700;\n  color: #5f7484;\n}\n\n.ob-tip-skip:hover {\n  color: #0b1e2d;\n}\n\n.ob-tip-title {\n  margin: 0 0 8px;\n  font-size: 18px;\n  font-weight: 800;\n  color: #0b1e2d;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n}\n\n.ob-tip-body {\n  font-size: 13.5px;\n  line-height: 1.55;\n  color: #5f7484;\n}\n\n.ob-tip-hint {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #f4fbf9;\n  border: 1px solid #d5efe8;\n}\n\n.ob-tip-hint-label {\n  display: block;\n  margin-bottom: 2px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #0d9b87;\n}\n\n.ob-tip-hint p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #0b1e2d;\n}\n\n.ob-tip-dots {\n  display: flex;\n  gap: 6px;\n  margin: 14px 0 12px;\n}\n\n.ob-tip-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 99px;\n  background: #dfe7e8;\n}\n\n.ob-tip-dot.is-done {\n  background: #7fe9d2;\n}\n\n.ob-tip-dot.is-on {\n  width: 18px;\n  background: #0d9b87;\n}\n\n.ob-tip-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.ob-tip-btn {\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.ob-tip-btn--ghost {\n  border: 1px solid #dfe7e8;\n  background: #fff;\n  color: #0b1e2d;\n}\n\n.ob-tip-btn--primary {\n  border: 0;\n  background: #00146d;\n  color: #fff;\n}\n\n.ob-anchor-tip {\n  position: fixed;\n  z-index: 10050;\n  pointer-events: auto;\n  filter: drop-shadow(0 18px 36px rgba(5, 14, 46, 0.22));\n}\n\n.ob-anchor-tip .ob-tip {\n  position: relative;\n}\n\n.ob-anchor-tip--right .ob-tip::before,\n.ob-anchor-tip--left .ob-tip::before,\n.ob-anchor-tip--bottom .ob-tip::before,\n.ob-anchor-tip--bottom-end .ob-tip::before,\n.ob-anchor-tip--top .ob-tip::before {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 8px solid transparent;\n}\n\n.ob-anchor-tip--right .ob-tip::before {\n  left: -16px;\n  top: 22px;\n  border-right-color: #fff;\n}\n\n.ob-anchor-tip--left .ob-tip::before {\n  right: -16px;\n  left: auto;\n  top: 22px;\n  border-left-color: #fff;\n}\n\n.ob-anchor-tip--bottom .ob-tip::before,\n.ob-anchor-tip--bottom-end .ob-tip::before {\n  top: -16px;\n  left: 28px;\n  border-bottom-color: #fff;\n}\n\n.ob-anchor-tip--bottom-end .ob-tip::before {\n  left: auto;\n  right: 28px;\n}\n\n.ob-anchor-tip--top .ob-tip::before {\n  bottom: -16px;\n  top: auto;\n  left: 50%;\n  margin-left: -8px;\n  border-top-color: #fff;\n}\n\n@media (max-width: 820px) {\n  .ob-card {\n    grid-template-columns: 1fr;\n  }\n\n  .ob-rail {\n    min-height: 140px;\n  }\n\n  .ob-main {\n    padding: 22px 18px 18px;\n  }\n\n  .ob-title {\n    font-size: 22px;\n  }\n\n  .ob-foot {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ob-foot-actions {\n    justify-content: stretch;\n  }\n\n  .ob-foot-actions .ob-btn {\n    flex: 1;\n  }\n\n  .ob-pillars--grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
